import { render } from "./ChapterOutro.vue?vue&type=template&id=3c76c6fc"
import script from "./ChapterOutro.vue?vue&type=script&lang=js"
export * from "./ChapterOutro.vue?vue&type=script&lang=js"

import "./ChapterOutro.vue?vue&type=style&index=0&id=3c76c6fc&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__